export const IMAGE_FORMATS = {
  FORMAT_16_9: "169",
  FORMAT_16_6: "166",
  FORMAT_3_4: "34",
  FORMAT_1_1: "carre",
  FORMAT_1_1_ROUND: "round",
  FORMAT_2_3: "23",
  FORMAT_16_3: "163",
} as const;

export type ImageFormatKeys = keyof typeof IMAGE_FORMATS;

export type ImageFormat = (typeof IMAGE_FORMATS)[ImageFormatKeys];

export type HorizontalImageFormat =
  | typeof IMAGE_FORMATS.FORMAT_16_9
  | typeof IMAGE_FORMATS.FORMAT_16_6
  | typeof IMAGE_FORMATS.FORMAT_16_3;

export enum PictureKeys {
  PICTURE_16_3 = "cover_picture_16_3",
  PICTURE_16_6 = "cover_picture_16_6",
  PICTURE_16_9 = "cover_picture_16_9",
  PICTURE_1_1 = "cover_picture_1_1",
  PICTURE_2_3 = "cover_picture_2_3",
  PICTURE_3_4 = "cover_picture_3_4",
}

export const DEFAULT_IMAGE_FORMATS: ImageFormat[] = [
  IMAGE_FORMATS.FORMAT_16_6,
  IMAGE_FORMATS.FORMAT_16_9,
  IMAGE_FORMATS.FORMAT_3_4,
  IMAGE_FORMATS.FORMAT_1_1,
];

export const ADDITIONNAL_IMAGE_FORMATS: ImageFormat[] = [
  IMAGE_FORMATS.FORMAT_2_3,
  IMAGE_FORMATS.FORMAT_16_3,
];

export interface ImageRatio {
  label: string;
  ratio: number;
  id: PictureKeys;
}

export const DEFAULT_IMAGE_RATIOS: ImageRatio[] = [
  {
    label: "16:6",
    id: PictureKeys.PICTURE_16_6,
    ratio: 16 / 6,
  },
  {
    label: "16:9",
    id: PictureKeys.PICTURE_16_9,
    ratio: 16 / 9,
  },
  {
    label: "3:4",
    id: PictureKeys.PICTURE_3_4,
    ratio: 3 / 4,
  },
  {
    label: "1:1",
    id: PictureKeys.PICTURE_1_1,
    ratio: 1 / 1,
  },
];

export const ADDITIONNAL_IMAGE_RATIOS: ImageRatio[] = [
  {
    label: "2:3",
    id: PictureKeys.PICTURE_2_3,
    ratio: 2 / 3,
  },
  {
    label: "16:3",
    id: PictureKeys.PICTURE_16_3,
    ratio: 16 / 3,
  },
];
